import { render, staticRenderFns } from "./initiate.vue?vue&type=template&id=184875f1&scoped=true"
import script from "./initiate.vue?vue&type=script&lang=js"
export * from "./initiate.vue?vue&type=script&lang=js"
import style0 from "./initiate.vue?vue&type=style&index=0&id=184875f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184875f1",
  null
  
)

export default component.exports